import { useEffect } from 'react';

const PTSBusinessCardRedirect = () => {
  useEffect(() => {
    window.location.href = "https://piercetechnologysolutions.com/business-card";
  }, []);

  return null;
};

export default PTSBusinessCardRedirect;





